import { useQuery } from "@tanstack/react-query";
import {
	getStraightenerPickers,
	getStraightenerRuns,
	type GetStraightenerRunsParams,
} from "../repositories/StraightenerRunsRepository";

type UseStraightenerRunsParams = Omit<GetStraightenerRunsParams, "signal"> & {
	enabled?: boolean;
};

export const useStraightenerRuns = ({
	start,
	end,
	productSizeId = null,
	enabled = true,
}: UseStraightenerRunsParams) => {
	return useQuery({
		queryKey: ["straightenerRuns", start, end, productSizeId],
		queryFn: ({ signal }) =>
			getStraightenerRuns({
				start,
				end,
				productSizeId,
				signal,
			}),
		enabled: enabled && !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};

export const useStraightenerPickers = () => {
	return useQuery({
		queryKey: ["straightenerPickers"],
		queryFn: ({ signal }) => getStraightenerPickers({ signal }),
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
